import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import {
  ArticleDetailUtil,
  EArticleClass,
  IGalleryArticleDetail,
  IRichArticleDetail,
  IVideoArticleDetail,
} from 'shared/models';
import { FC } from 'react';
import { loadable } from 'jotai/utils';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const ArticlePreload: FC = () => {
  const loadableArticle = useAtomValue(loadable($CurrentArticle));

  if (loadableArticle.state !== 'hasData') {
    return null;
  }

  const article = loadableArticle.data;

  if (!ArticleDetailUtil.isArticleAvailable(article)) {
    return null;
  }

  let preloadUrl: string;
  if (article.articleClass === EArticleClass.GALLERY) {
    preloadUrl = (article as IGalleryArticleDetail).imageList[0].url;
  } else {
    preloadUrl = (article as IRichArticleDetail | IVideoArticleDetail).largeImage.url;
  }

  return (
    <DynamicHead>
      <link rel="preload" as="image" href={preloadUrl} />
    </DynamicHead>
  );
};
